export default function Footer() {
    return (
        <footer className={'arc3-typo--text-center arc3-padding-lg'}>
            <a href="https://albelli-careers.com/vacancies/senior-full-stack-engineer/">
                Apply now @Albelli Careers
            </a>
        </footer>
    );
}
